import { CURRENCY_CODE } from "@/lib/constant";
import { sendGTMEvent } from "@next/third-parties/google";
import { formatItems } from "@repo/lib/helpers";
import { useFeatureFlag } from "@repo/lib/hooks/common";
import { useCallback } from "react";

const usePurchaseEvent = () => {
  const isGTMEnabled = useFeatureFlag("gtm");
  const handlePurchaseEvent = useCallback(
    (data) => {
      if (!isGTMEnabled) {
        return;
      }
      const { transactionId, lineItems, amounts } = data || {};
      sendGTMEvent({
        event: "purchase",
        transaction_id: transactionId,
        value: amounts?.total,
        tax: amounts?.tax,
        shipping: amounts?.shippingCharges,
        currency: CURRENCY_CODE,
        coupon: amounts?.couponName || "",
        items: formatItems(lineItems, amounts?.couponName),
      });
    },
    [isGTMEnabled]
  );

  return { handlePurchaseEvent };
};

export default usePurchaseEvent;
